import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PRICE } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return;
}